import { motion } from "framer-motion";
import { BRAND } from "@/data/products";

const PILLARS = [
  {
    n: "01",
    t: "The Stone of Kings",
    d: "We work exclusively with Grade 1 Makrana Sangmarmar — the same marble used to build the Taj Mahal, Victoria Memorial and Dilwara temples.",
  },
  {
    n: "02",
    t: "Master Craftsmanship",
    d: "Every carving is done by hand by karigars trained in traditions passed down through generations of Rajasthani marble artistry.",
  },
  {
    n: "03",
    t: "Made to Order",
    d: "Every piece is a pre-order commission, carved to your dimensions, iconography and space — from a home temple to a full outdoor mandir.",
  },
  {
    n: "04",
    t: "Worldwide Shipping",
    d: "Packed with care and shipped to homes, temples and estates across India — exported to 100+ countries including the Gulf, UK, USA and Australia.",
  },
];

export default function Heritage() {
  return (
    <section
      id="heritage"
      data-testid="heritage-section"
      className="relative py-24 md:py-32 bg-ink-deep text-cream-100 overflow-hidden"
    >
      {/* subtle gold pattern */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 25% 20%, #D4A93A 1px, transparent 1px), radial-gradient(circle at 75% 80%, #D4A93A 1px, transparent 1px)",
          backgroundSize: "80px 80px",
        }}
      />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-[1fr_1.2fr] gap-14 lg:gap-24 items-start">
        <div>
          <div className="text-[11px] tracking-[0.32em] uppercase text-gold-light mb-5">
            — The Vardaan Legacy
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
            A tradition
            <br />
            carved from
            <br />
            <span className="italic gold-text">sacred stone.</span>
          </h2>
          <p className="text-cream-100/70 mt-8 text-base leading-relaxed max-w-md">
            Founded in {BRAND.established}, Vardaan Arts brings together
            Makrana's centuries-old marble heritage and the artistry of
            Rajasthan's finest karigars. Every temple, statue and sculpture we
            create is a devotional piece — designed for a lifetime.
          </p>

          <div className="mt-10 border border-gold/30 p-6 bg-cream-100/[0.03]">
            <div className="text-[10px] tracking-[0.28em] uppercase text-gold-light mb-3">
              Our Promise
            </div>
            <p className="font-serif italic text-2xl leading-snug text-cream-100">
              "Same marble as the Taj Mahal — carved with the same devotion."
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-5">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: 0.7,
                delay: i * 0.1,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="relative p-8 border border-gold/25 bg-cream-100/[0.02] hover:border-gold/60 transition-colors duration-500"
              data-testid={`pillar-${p.n}`}
            >
              <div className="font-serif italic text-gold-light text-3xl">
                {p.n}
              </div>
              <h3 className="font-serif text-2xl text-cream-100 mt-4">
                {p.t}
              </h3>
              <p className="text-cream-100/65 mt-3 text-sm leading-relaxed">
                {p.d}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
